export default __webpack_public_path__ + "static/media/cube_cat.db08ade2.png";